import * as Constants from '../constants';

export function requestAnnotateAesopObjects({
  pandoraIds,
  withProgress = true,
  dedupeAnnotationsRequest = false,
  ignoreAnnotations = false,
}) {
  return {
    type: Constants.Annotations.ActionTypes.REQUEST_ANNOTATE_AESOP_OBJECTS,
    data: {
      pandoraIds,
      withProgress,
      // If true, dedupeAnnotationsRequest will exclude episodes that already have annotations
      dedupeAnnotationsRequest,
      // If true, ignoreAnnotations will prevent the actual annotations returned from Aesop
      // from being stored in state. We'll only store 'progress' and 'newEpisodeBadge' data
      ignoreAnnotations,
    },
  };
}

export function ensureFullDataActionCreator(idVerifier, idFetcher) {
  return ids => {
    return {
      type: Constants.Annotations.ActionTypes.ENSURE_FULL_DATA,
      data: {
        ids,
        idVerifier,
        idFetcher,
      },
    };
  };
}

export function annotateIds(ids = [], annotateAlbumTracks = true) {
  return {
    type: Constants.Annotations.ActionTypes.ANNOTATE_IDS,
    ids,
    annotateAlbumTracks,
  };
}

export const overwriteAnnotations = annotations => ({
  type: Constants.Annotations.ActionTypes.OVERWRITE_ANNOTATIONS,
  data: {
    annotations,
  },
});
